import React from 'react';
import { TagsModal } from '../../../../../../../components';

type tagAction = 'add' | 'delete';
type PanelTagsProps = {
  applicationId: string;
  currentTags: string[];
  disabled: boolean;
  triggerRender: number;
  tagOptions: string[];
  handlePreUpdateAddTag: (
    applicationId: string,
    action: tagAction,
    currentTags: string[],
    tag: string,
  ) => Promise<void>;
};

const PanelTags: React.FunctionComponent<PanelTagsProps> = (
  props: PanelTagsProps,
) => {
  const {
    applicationId,
    currentTags,
    triggerRender,
    disabled,
    tagOptions,
    handlePreUpdateAddTag,
  } = props;
  const currentValidTags = currentTags.filter(tag => tagOptions.includes(tag));
  return (
    <TagsModal
      key={applicationId + triggerRender}
      selectedTags={currentValidTags}
      tagOptions={tagOptions}
      disabled={disabled}
      onDelete={async tag => {
        await handlePreUpdateAddTag(
          applicationId,
          'delete',
          currentValidTags,
          tag,
        );
      }}
      onAdd={async tag => {
        await handlePreUpdateAddTag(
          applicationId,
          'add',
          currentValidTags,
          tag,
        );
      }}
    />
  );
};
const MemoizedPanelTags = React.memo(PanelTags);
export { MemoizedPanelTags };
